<template>
    <div class="card" style="min-height: 300px;">
        <div v-if="!getStarted">
            <h5>
                To help you find the best energy deal for your new home, we'll ask you a few quick questions about
                your
                house move. Based on your answers, we'll guide you through the right energy comparison journey:
            </h5>

            <p class="_margin-top-10 _margin-bottom-0">
                <b>If you have yet to exchange:</b> You'll be able to review available energy deals and come back to
                switch once your move is finalised.
            </p>
            <p class="_margin-bottom-0">
                <b>If you have already exchanged:</b> We'll ask you to provide us with your completion date to
                understand if you're eligible to switch.
            </p>
            <p class="_margin-bottom-0">
                This way, we can ensure everything is timed perfectly for your move.
            </p>

            <div class="text-center _margin-top-30">
                <uiv-btn type="primary" @click="getStarted = true">Get Started</uiv-btn>
            </div>
        </div>

        <div v-else>
            <h4 class="_margin-top-10">Have you exchanged?</h4>

            <div class="row">
                <div class="col-xs-6 col-sm-4 col-md-3">
                    <radio-button v-model="quote.exchanged" :value="true"
                        @change="quote.completionDate = null">Yes</radio-button>
                </div>

                <div class="col-xs-6 col-sm-4 col-md-3">
                    <radio-button v-model="quote.exchanged" :value="false"
                        @change="quote.completionDate = null">No</radio-button>
                </div>
            </div>

            <div class="row _margin-top-20" v-if="quote.exchanged">
                <div class="col-md-8">
                    <form-label id="completionDate">Enter your completion date</form-label>
                    <validation-messages label="Completion Date" :$v="$v.completionDate">
                        <date-field id="completionDate" v-model="quote.completionDate" :max-year="yearPlusOne"
                            :error="$v.completionDate.$error" />
                    </validation-messages>
                </div>
            </div>

            <div class="alert alert-info _margin-bottom-0" v-if="quote.exchanged == false">
                While you can't switch energy suppliers just yet, you can still explore available tariffs and see what's
                on offer. Once your move is further along, you can come back and switch!
            </div>

            <div class="alert alert-info _margin-top-20 _margin-bottom-0" v-show="withinCompleteDate()">
                Your completion date is still a little while away, and it's best to switch energy suppliers within 10
                days of completion to ensure you're on supply from the day you move in. However, you can still review
                the available deals and see what's on offer. Once your completion date approaches, you can return and
                switch!
            </div>
        </div>
    </div>
</template>

<script>
import RadioButton from '../../../../base/components/forms/RadioButton';
import { mapState } from 'vuex';

export default {
    name: 'GetStarted',
    data() {
        return {
            yearPlusOne: new Date().getFullYear() + 2,
            getStarted: false
        }
    },
    props: {
        $v: Object
    },
    computed: {
        ...mapState({
            quote: ({ quote }) => quote
        })
    },
    methods: {
        withinCompleteDate() {
            if (!this.quote.completionDate) return false;
            const date = new Date();
            // 9 days from now
            const future = date.setDate(date.getDate() + 9);
            return new Date(this.quote.completionDate) > future;
        }
    },
    components: {
        RadioButton
    }
};
</script>

<style lang="scss"></style>
